export default {
    playerTypeConfig: [
        {
            label: 'Regular',
            value: 'false',
        },
        {
            label: 'Sticky',
            value: 'true',
        },
    ],
    position: [
        {
            label: 'Top',
            value: 'top',
        },
        {
            label: 'Bottom',
            value: 'bottom',
        },
    ],
    controlsConfig: [
        {
            label: 'Speed',
            value: 'speed',
        },
        {
            label: 'Skip/Rewind',
            value: 'rewind',
        },
    ],
    buttonsConfig: [
        {
            label: 'Subscribe',
            value: 'subscribe',
        },
        {
            label: 'Share',
            value: 'share',
        },
        {
            label: 'Download',
            value: 'download',
        },
    ],
    ctaButton: {
        ctaConfig: [
            {
                label: 'Open URL in new window',
                value: '_blank',
            },
            {
                label: 'Open URL in the same window',
                value: '_self',
            },
        ],
        ctaButtonTextLabel: [
            {
                label: '(15 chars max)',
            },
        ],
        ctaUrlConfig: [
            {
                value: 'https://',
            },
        ],
    },
    freeOptions: {
        type: ['regular'],
        buttons: ['subscribe'],
    },
    freePlayerColorsConfig: [
        {
            label: 'Default',
            value: '#453F5E',
        },
        {
            label: 'Black',
            value: '#000000',
        },
        {
            label: 'White',
            value: '#ffffff',
        },
    ],
};
